import { Action } from '@ngrx/store';

export class EnvironmentAction implements Action {

    public static getEnvironmentMachine: string = '[Environment] get_environment_machine';
    public static getEnvironmentMachineError: string = '[Environment] get_environment_machine_error';
    public static getEnvironmentMachineSuccess: string = '[Environment] get_environment_machine_success';

    public static getEnvironments: string = '[Environment] get_environments';
    public static getEnvironmentsError: string = '[Environment] get_environments_error';
    public static getEnvironmentsSuccess: string = '[Environment] get_environments_success';

    public static setCurrentEnvironment: string = '[Environment] set_current_environment';
    public static resetCurrentEnvironment: string = '[Environment] reset_current_environment';

    public static enableEnvironmentSwitching: string = '[Environment] enable_environment_switching';
    public static disableEnvironmentSwitching: string = '[Environment] disable_environment_switching';

    public static switchToNextAvaliableEnvironmentError: string = '[Environment] switch_to_next_avaliable_environment_error';
    public static switchToNextAvaliableEnvironmentSuccess: string = '[Environment] switch_to_next_avaliable_environment_success';
    public static switchToNextAvaliableEnvironmentErrorOutdated: string = '[Environment] switch_to_next_avaliable_environment_error (outdated)';

    public static resetEnvironmentState: string  = '[Environment] reset_environment_state';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
